// extracted by mini-css-extract-plugin
module.exports = {"container":"RecipeCard_container__71CyJ"};